import * as React from 'react';

import { log } from 'helper/debug';
import noop from 'helper/noop';

import ButtonBar from 'components/molecules/ButtonBar';
import CardLike from 'components/molecules/Card/elements/Like';

import { ContainerCardDetailProductPropsType } from 'containers/molecules/Card/Detail/Product';

import { ProductWidget } from '@migros/msrc-articles';
import { ProductWidgetConfig } from '../../../../defs/msrc';
import i18n from '../../../../helper/i18n';

export type CardDetailProductPropsType = ContainerCardDetailProductPropsType;

type CardDetailProductState = {
	productTitle: string;
};

export class CardDetailProduct extends React.Component<CardDetailProductPropsType, CardDetailProductState> {
	public static displayName = 'CardDetailProduct';
	public static defaultProps = {
		doHeart: noop,
		doComplete: noop,
		doClose: noop,
	};

	public productRef;

	public componentDidMount() {
		this.addMsrcMessengerListener();
	}

	public handleButtonClicks = (buttonType: string) => {
		if (this.props.isSequenceLoading) {
			return;
		}

		switch (buttonType) {
			case 'completed':
				this.props.onClickHeart({
					type: this.props.type,
					buttonType,
					onAnimationDone: () => {
						this.props.doHeart(`${this.props.id}`);
						this.props.doComplete(`${this.props.id}`);
					},
				});
				break;
			default:
				log(`Button Action "${buttonType}" not available`);
		}
	};

	public renderButtonBar() {
		const { isCheckable, isUiUpdatingHeart, isUiClosing } = this.props;
		let cardButtons: any = null;

		if (!isCheckable) {
			return null;
		}

		if (!this.props.isDone) {
			cardButtons = {
				buttons: [
					{
						loading: isUiUpdatingHeart,
						disabled: isUiClosing,
						knob: {
							modifier: 'dashed-green',
							size: 'l',
							icon: 'completed',
						},
					},
				],
			};
		}

		if (cardButtons === null) {
			return null;
		}

		return (
			<div className="m-card__button-bar">
				<ButtonBar handleButtonClicks={this.handleButtonClicks} buttons={cardButtons.buttons} />
			</div>
		);
	}

	public async addMsrcMessengerListener() {
		(await window.msrc.messenger.getInstance()).subscribe(
			'articles:product-not-found',
			async ({ productId, removeElement, widgetContainerNode }) => {
				if (productId === this.props.productId) {
					// just hide the product if it does not exist anymore
					$(this.productRef)
						.closest('.m-card')
						.hide();
				}
			}
		);
	}

	public render() {
		const { handleCardContentClick, productId, favorite, handleToggleFavorite } = this.props;

		if (!productId || productId.length === 0) {
			return null;
		}

		const {
			layout,
			headingTagsLevel,
			hideRating,
			environment,
			webAPIKey,
			language,
			filterOptions,
		} = ProductWidgetConfig;

		return (
			<div
				className="m-card__content"
				onClick={handleCardContentClick}
				ref={(productComponent: HTMLDivElement) => (this.productRef = productComponent)}
			>
				<div className="m-card__info">
					<h4 className="m-card__info-title js-m-card__info-title">
						{i18n('react.impulsCoach.components.cardDetail.product.title')}
					</h4>
				</div>

				<div className="m-card__product">
					<ProductWidget
						environment={environment}
						productId={productId}
						webAPIKey={webAPIKey}
						layout={layout}
						headingTagsLevel={headingTagsLevel}
						language={language}
						hideRating={hideRating}
						filterOptions={filterOptions}
					/>

					<div className="m-card__product-favorite">
						<CardLike liked={favorite} onClick={handleToggleFavorite} modifier="product" />
					</div>
				</div>
				{this.renderButtonBar()}
			</div>
		);
	}
}

export default CardDetailProduct;
